import React, { useState, useEffect } from 'react';
import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import CusProgressBar from '../components/CusProgressBar';
import CusRadioButton from "../components/CusRadioButton";
import comdetailsdata from '../data/comdetailsdata.json';
import {blockValidator, streetValidator, levelValidator, unitNoValidator, buildingValidator, postalCodeValidator} from '../validation/Validators'
import { FormInput, CusFormInput, CusFormLabel, FormTitle, CusFormInput2, FormSubTitleTooltip } from '../validation/Form-Components';
import config from '../appconfig/config.json';
import service from '../services/ApiService';
import { useHistory } from "react-router-dom";
import companyTypes from '../data/companytype.json';
import Loading from '../components/Loading';
import SubHeader from '../components/SubHeader';
import helper from '../factory/Helper';
import storage from '../factory/StorageFactory';
import { ComboBox } from "@progress/kendo-react-dropdowns";
import CusToast from '../components/CusToast';
import myInfoCountries from '../data/myInfoCountryList.json';
 
const CompanyDetails = (props) => {
   
    let timer;
    const history = useHistory();
    const detailsType = '0';  // for api call, 0 for Company Details
    const item = { bgcolor: "#389A6E", completed: 10 };
    const secretaryCode = '28';
    const numericRegex = new RegExp(/^[0-9]+$/);
    const compTypeValidationMessage = "Select drop down list (Business Type)";
    
    const [selectedValue, setSelectedValue] = useState('Y');  //default 'Y'
    const [showMailing, setShowMailing] = useState(false); // defalut false
    const [isLocal, setIsLocal] = useState(true); // default true
    const [isLoading, setIsLoading] = useState(true); //defult true
    const [isSaving, setIsSaving] = useState(false);
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [selectedCompType, setSelectedCompType] = useState();

    const initialResponseState = {
        CompDtls:{
            RegNo: "",
            CompName: "",
            CompType: "",
            DtOfInc: "",
            CompTypeCode:"",
            CountryOfInc: "",
            EntityStatus:"",
        },
        RegBizAddr:{
            AddType:"",
            BlkNo: "",
            Street: "",
            FlrNum: "",
            UnitNo: "",
            BldName: "",
            PostalCode: "",
            AddLine1:"",
            AddLine2:"",
            Country:""
        },
        RegBizMailAddr: {
            SameAsRegBizAddr: '',
            AddType: "",
            BlkNo: "",
            Street: "",
            FlrNum: "",
            UnitNo: "",
            BldName: "",
            PostalCode: "",
            Country: ""
        },
        ApplicantsDtlsMyInfo:{},
        Holdersdetails:[]
    };

    const [response, setResponse] = useState(initialResponseState);

    const [mailingAddress, setMailingAddress] = useState({
        comType:"",
        BlkNo: "",
        Street: "",
        FlrNum: "",
        UnitNo: "",
        BldName: "",
        PostalCode: "",
        Country: comdetailsdata.defCountry.label
    });


    useEffect(() => {
        console.log('@CompanyDetails useEffect');
        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }
   
        window.scrollTo(0,0);
     
        getCompanyDetails();

        return () => clearTimeout(timer);
    }, []);

    const getStateId = () => {  // get State Id from query string and store in localhost
    
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        let stateId = parsed.state;
        storage.setStateId(stateId);
    }

    const getCompanyDetails = () => {
        getStateId();
        service.get().then( res => {
            setIsLoading(false);
            if(res.data.isSucess) {
                if(res.data.model.fields.Data === "Empty") {  //MyInfo user click close, route to Product page.
                    goToErrorPage(config.ErrType.EmptyCompDtls);
                }
                else if(isLoginUserSecretary(res.data.model.fields.request.ApplicantsDtlsMyInfo.Designation)) {
                    goToErrorPage(config.ErrType.InvalidPosition);
                }
                else if(!isValidCompTypeCode(res.data.model.fields.request.CompDtls.CompTypeCode)){
                    goToErrorPage(config.ErrType.InvalidCompType);
                }
                else if(!isValidMyInfoFields(res.data.model.fields.request)) {
                    //goToErrorPage(config.ErrType.InvalidMyInfoBiz);
                    showErrMsg(config.error.MyInfo.MissingData);
                    setResponse(res.data.model.fields.request);
                    bindFormData(res.data.model.fields.request);
                }
                else {
                    setResponse(res.data.model.fields.request);
                    bindFormData(res.data.model.fields.request);
                    checkInvalidCases(res.data.model.fields.request);
                }
            }
            else {
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }
    
    const clearMailingAddr = () => {
        setMailingAddress({ 
            BlkNo: "",
            Street: "",
            FlrNum: "",
            UnitNo: "",
            BldName: "",
            PostalCode: "",
            Country: comdetailsdata.defCountry.label});
    }

    const bindFormData = (data) => {
        try{
            if(data.ProductType.length > 0) {
                storage.setProductType(data.ProductType);
            }
            if(data.CompDtls.CompTypeCode === null) {  //check my info returns null, if null then set value
                setSelectedCompType(helper.getObjInArray(data.RegBizMailAddr.CompTypeCode,companyTypes));
            }
            if(data.RegBizMailAddr.SameAsRegBizAddr === null) { // first time
                if(data.RegBizAddr.AddType === config.addTypeLocal) {
                    setIsLocal(true);
                    setSelectedValue('Y');
                    setShowMailing(false);
                }
                else if(data.RegBizAddr.AddType === config.addTypeLocalUnformat) {
                    setIsLocal(false);
                    setSelectedValue('Y');
                    setShowMailing(false);
                }
                else {
                    setIsLocal(false);
                    setSelectedValue('N');
                    setShowMailing(true);
                }
                clearMailingAddr();
            }
            else if(data.RegBizMailAddr.SameAsRegBizAddr === 'Y') {  
                setIsLocal(data.RegBizAddr.AddType === config.addTypeLocal? true: false);
                setSelectedValue('Y');
                setShowMailing(false);
            }
            else {  //false
                setIsLocal(data.RegBizAddr.AddType === config.addTypeLocal? true: false);
                setMailingAddress({
                    BlkNo: data.RegBizMailAddr.BlkNo !==null? data.RegBizMailAddr.BlkNo:'',
                    Street: data.RegBizMailAddr.Street !==null? data.RegBizMailAddr.Street:'',
                    FlrNum: data.RegBizMailAddr.FlrNum !==null? data.RegBizMailAddr.FlrNum:'',
                    UnitNo: data.RegBizMailAddr.UnitNo !==null?data.RegBizMailAddr.UnitNo:'' ,
                    BldName: data.RegBizMailAddr.BldName !==null?data.RegBizMailAddr.BldName:'',
                    PostalCode: data.RegBizMailAddr.PostalCode !==null?data.RegBizMailAddr.PostalCode:'',
                    Country: comdetailsdata.defCountry.label   
                });
                setSelectedValue('N');
                setShowMailing(true);
            }
        }
        catch(e) {

        }
    }

    const isValidCompTypeCode = (compTypeCode) => {
        let isValid = true;
        if(compTypeCode === null) {
            isValid = false
        }
       
        return isValid;
    }

    const isLoginUserSecretary = (designation) => {
        let isValid = false;
        if(designation === '28') {
            isValid = true;
        }

        return isValid;
    }

    const checkNumOfDirectors = (data) => {
        
        let holdersTemp = [];
        if(Array.isArray(data.Holdersdetails)){
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNum !== null && data.Holdersdetails[i].Name !== null) {
                    if(data.Holdersdetails[i].Designation !== secretaryCode) {
                        holdersTemp.push(data.Holdersdetails[i]);
                    }
                }
            }
        }
        else {
            if(data.Holdersdetails.IDNum !== null && data.Holdersdetails.Name !== null) {
                if(data.Holdersdetails.Designation !== secretaryCode) {
                    holdersTemp.push(data.Holdersdetails);
                }
            }
        }
        return holdersTemp;
    }

    const checkInvalidCases = (data) => {
        if(data.CompDtls.EntityStatus.trim().toUpperCase()  === 'NON-LIVE'){
            props.history.push(config.route.InvalidEntity,{errType:'NON-LIVE'});
        }
        else if(checkNumOfDirectors(data).length > 3) {
            props.history.push(config.route.InvalidDirectors);
        }
    }
    
    //check upon SME CASA Requirements_Error message for AP v2.1.docx
    const passDesignation = (designation) => {
        let pass = true;
        if(designation === '26') {  
            pass = true;
        } 
        else if(designation === '27') {
            pass = true;
        }
        else if(designation === '28') {
            pass = true;
        }
        else if(designation === '30') {
            pass = true;
        }
        else if(designation === '10') {
            pass = true;
        }
        else if(designation === '15') {
            pass = true;
        }
        else if(designation === '17') {
            pass = true;
        }
        else if(designation === '18') {
            pass = true;
        }
        else if(designation === '19') {
            pass = true;
        }
        else if(designation === '1') {
            pass = true;
        }
        else if(designation === '2') {
            pass = true;
        }
        else if(designation === '3') {
            pass = true;
        }
        else if(designation === '4') {
            pass = true;
        }
        else if(designation === '5') {
            pass = true;
        }
        else if(designation === '6') {
            pass = true;
        }
        else if(designation === '9') {
            pass = true;
        }
        else if(designation === '20') {
            pass = true;
        }
        else if(designation === '21') {
            pass = true;
        }
        else if(designation === '000') {
            pass = true;
        }
        else {
            pass = false;
        }
        return pass; 
    }

    const goToErrorPage = (errType) => {
         props.history.push(config.route.MyInfoError,{errType:errType});
    }

    const formatJsonParams = (data) => {
        let params = {};
        let bizType = {value:'',label:''};
        
        if(response.CompDtls.CompType === null) {
            bizType = selectedCompType;
        }
       
        if(selectedValue === 'Y'){
            params= {
                CurrentUser:currentUser(),
                ProductType:storage.getProductType(), //storage.getProductType()
                RegBizMailAddr:{
                    SameAsRegBizAddr: selectedValue,
                    CompTypeCode:bizType.value,
                    CompType:bizType.label
                },
                Source:storage.getFromSource()
            }
        }
        else{ 
            params = {
                CurrentUser:currentUser(),
                ProductType:storage.getProductType(), //storage.getProductType()
                RegBizMailAddr:{
                    SameAsRegBizAddr:selectedValue,  
                    AddType:config.addTypeLocal, 
                    BlkNo: data.BlkNo,
                    Street: data.Street,
                    FlrNum: data.FlrNum,
                    UnitNo: data.UnitNo,
                    BldName: data.BldName,
                    PostalCode: data.PostalCode,
                    Country: comdetailsdata.defCountry.value,
                    CompTypeCode:bizType.value,
                    CompType:bizType.label
                },
                Source:storage.getFromSource()
            }
        }
        return params;
    }

    const saveCompanyDetails = (params) => {
    
        if(!isValidMyInfoFields(response)) {
            showErrMsg(config.error.MyInfo.MissingData);
            return;
        }

        setIsSaving(true);
        service.post(detailsType,params).then( res => {
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }          
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
   
    const getAddressbyPostalCode = (postalCode) => {
        setIsSaving(true);
        const params = {
            'postalCode': postalCode
        }

        service.getAddress(postalCode).then(res=>{
            setIsSaving(false);
            let data= res.data.model;
            let resdata = data[0];
            // console.log('getAddress: ',resdata);
            // let data= res.data.d;
            // let resdata = JSON.parse(data);

            let blkno, building, street;
    
            if(resdata.blK_NO === '' || resdata.blK_NO === undefined || resdata.blK_NO === null) {
                blkno = '';
            }
            else {
                blkno = resdata.blK_NO;
            }
    
            if(resdata.bldG_NAME === '' || resdata.bldG_NAME === undefined || resdata.bldG_NAME === null) {
                building = '';
            }
            else {
                building = resdata.bldG_NAME;
            }
    
            if(resdata.sT_NAME === '' || resdata.sT_NAME === undefined || resdata.sT_NAME === null) {
                street = '';
            }
            else {
                street = resdata.sT_NAME;
            }
    
            setMailingAddress({
                FlrNum: '',
                UnitNo: '',
                BlkNo: blkno,
                Street: street,
                BldName: building,
                PostalCode:postalCode,
                Country: comdetailsdata.defCountry.label
            })
        })
        .catch(err => {
            console.log('@GetAddress: ',err);
            setIsSaving(false);
            showErrMsg('Unable to retrieve the address.');
        });
    }

    const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:null
        }
        return params
    }

    
    const handleSubmit = (dataItem) => {
        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }
 
        if(helper.isInvalidState()) {
            window.location.href =  config.link.Cancle;
            return;
        }

        if(dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
           saveCompanyDetails(formatJsonParams(data));
        }
    }

    const handleChange = React.useCallback(
        (e) => {
            setSelectedValue(e.value);
       
            if(e.value === 'N'){
                setShowMailing(true);
            }
            else{
                setShowMailing(false);
            }
            setMailingAddress({
                FlrNum: '',
                UnitNo: '',
                BlkNo: '',
                Street: '',
                BldName: '',
                PostalCode:'',
                Country: comdetailsdata.defCountry.label
            })
        },
        [setSelectedValue]
    );

    const getCountryDesc = (cValue) => {
        let desc = ''
        if(cValue!==null) {
            const obj = helper.getObjInArray(cValue,myInfoCountries);
            if(obj){
                desc = obj.label;
            }
        }
        return desc;
    }
 
    const handleCompType = (e) => {
        setSelectedCompType(e.value);
    }

    const isValidMyInfoFields = (resObj) => {
        let isValid = true;
        if(resObj.CompDtls.RegNo === null|| resObj.CompDtls.RegNo === "" || resObj.CompDtls.RegNo === undefined) {
            isValid = false;
        }
        else if(resObj.CompDtls.CompName === null|| resObj.CompDtls.CompName === "" || resObj.CompDtls.CompName === undefined) {
            isValid = false;
        }
        else if(resObj.CompDtls.DtOfInc === null|| resObj.CompDtls.DtOfInc === "" || resObj.CompDtls.DtOfInc === undefined) {
            isValid = false;
        }
        // else if(resObj.CompDtls.CountryOfInc === null|| resObj.CompDtls.CountryOfInc === "" || resObj.CompDtls.CountryOfInc === undefined) {
        //     isValid = false;
        // }
        else if(resObj.RegBizAddr.AddType === null || resObj.RegBizAddr.AddType === "" || resObj.RegBizAddr.AddType === undefined) {
            isValid = false;
        }
        else if(resObj.RegBizAddr.AddType === config.addTypeLocal) {
            if(resObj.RegBizAddr.PostalCode === null || resObj.RegBizAddr.PostalCode === "" || resObj.RegBizAddr.PostalCode === undefined) {
                isValid = false;
            }
            else if(resObj.RegBizAddr.BlkNo === null || resObj.RegBizAddr.BlkNo === "" || resObj.RegBizAddr.BlkNo === undefined){
                isValid = false;
            }
            else if(resObj.RegBizAddr.Street === null || resObj.RegBizAddr.Street === "" || resObj.RegBizAddr.Street === undefined) {
                isValid = false;
            }
        }
        else if(resObj.RegBizAddr.AddType === config.addTypeLocalUnformat || resObj.RegBizAddr.AddType === config.addTypeForeign) {
            if(resObj.RegBizAddr.AddLine1 === null || resObj.RegBizAddr.AddLine1 === "" || resObj.RegBizAddr.AddLine1 === undefined) {
                isValid = false;
            }
            else if(resObj.RegBizAddr.AddLine2 === null || resObj.RegBizAddr.AddLine2 === "" || resObj.RegBizAddr.AddLine2 === undefined){
                isValid = false;
            }
        } 

        return isValid;
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            props.history.push(config.route.AccountOpening);
        }
    }
     
    if(isLoading) {
        return(
            <Loading />
        )
    }
    return(
        <div className="container-fluid">
            <SubHeader /><br/>
            <Form onSubmitClick={handleSubmit} 
                    initialValues={mailingAddress}
                    key={JSON.stringify(mailingAddress)}
                    render={(formRenderProps)=>(
                        <FormElement>
                            <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} id={'ft1'} name={comdetailsdata.formContainerTitle[0].name}/> 

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblRegNo'} leftLabelName={comdetailsdata.label.RegNo}
                                    id={'RegNo'} name={response.CompDtls.RegNo !==null? response.CompDtls.RegNo:''} />
                              
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCompName'} leftLabelName={comdetailsdata.label.CompName}
                                    id={'CompName'} name={response.CompDtls.CompName !==null? response.CompDtls.CompName:''} />
                             
                                {response.CompDtls.CompType !==null ?
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCompType'} leftLabelName={comdetailsdata.label.CompType}
                                    id={'lblcompType'} name={response.CompDtls.CompType !==null? response.CompDtls.CompType:''} />
                                :
                                <div className="row around-xs inputPair elementVisible">
                                    <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box" style={{ marginTop: "5px" }} id={'lblCompType'}>
                                        {comdetailsdata.label.CompType}
                                    </div>
                                    </div>
                                    <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box"> 
                                        <ComboBox  id={'ddlComType'}  data={companyTypes}
                                            textField={'label'} dataItemKey={'value'}
                                            placeholder={'Please select'}
                                            value={selectedCompType} 
                                            onChange={handleCompType} 
                                            allowCustom={true}
                                            required={true}
                                            validationMessage={compTypeValidationMessage}
                                        />
                                    </div>
                                    </div>
                                </div>}
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblDtOfInc'} leftLabelName={comdetailsdata.label.DtOfInc}
                                    id={'dtOfInc'} name={response.CompDtls.DtOfInc !==null? response.CompDtls.DtOfInc:''} />
                            
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCountryOfInc'} leftLabelName={comdetailsdata.label.CountryOfInc}
                                    id={'countryOfInc'} name={response.CompDtls.CountryOfInc !==null? getCountryDesc(response.CompDtls.CountryOfInc):"SINGAPORE"} />
                              <FieldWrapper></FieldWrapper>
                                </fieldset>
                             
                            </FormContainer>

                            <FormContainer>
                            <fieldset>
                            <Field component={FormSubTitleTooltip} 
                                id={'ft2'} name={comdetailsdata.formContainerTitle[1].name}
                                tooltipPosition={'right'} tooltipAchor={'target'} 
                                tooltipTitle={'Applies to this account only. Correspondence address for existing accounts (where applicable) will not be changed.'} /> 
                                {!isLocal ?
                                <div>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine1}
                                    id={'addline1'} name={response.RegBizAddr.AddLine1 !==null? response.RegBizAddr.AddLine1:''}/>

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine2}
                                    id={'addline1'} name={response.RegBizAddr.AddLine2 !==null? response.RegBizAddr.AddLine2:''}/>
                                  
                                </div> : null }
                                {isLocal ?
                                <div>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                                    id={'blk'} name={response.RegBizAddr.BlkNo !== null? response.RegBizAddr.BlkNo:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                                    id={'st'} name={response.RegBizAddr.Street !==null? response.RegBizAddr.Street:''} />
                             
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblLvl'} leftLabelName={comdetailsdata.label.FlrNum} 
                                    id={'lvl'} name={response.RegBizAddr.FlrNum !==null? response.RegBizAddr.FlrNum:''}  />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                                    id={'uno'} name={response.RegBizAddr.UnitNo !==null? response.RegBizAddr.UnitNo:''}  />
                               
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                                    id={'bld'} name={response.RegBizAddr.BldName !==null? response.RegBizAddr.BldName:''}  />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                                    id={'ptc'} name={response.RegBizAddr.PostalCode !==null? response.RegBizAddr.PostalCode:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'ctry'} name={getCountryDesc(response.RegBizAddr.Country)}/>
                                </div> :null}

                                <CusRadioButton name="SameAsRegBizAddr" leftValue='Y' rightValue='N' disabled={false}
                                    label={comdetailsdata.label.SameAsRegBizAddr} onChange={handleChange} checkedValue={selectedValue} />
                                
                                { !showMailing ?
                                    <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} /> : null }

                                { !showMailing ?
                                <div className="row around-xs inputPair elementVisible">
                                    <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="text-right" style={{ paddingBottom: "20px" }}>
                                        <div>
                                            <button type={'submit'} className="k-button btn btn-success" disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                        </div>
                                        </div>
                                    </div>
                                </div>: null }

                            </fieldset>
                            </FormContainer>
                            
                            { showMailing ?
                            <FormContainer>
                            <fieldset>
                                <Field component={FormSubTitleTooltip} id={'ft3'} name={comdetailsdata.formContainerTitle[2].name}
                                    tooltipPosition={'right'} tooltipAchor={'target'} tooltipTitle={'Applies to this account only. Mailing address of existing accounts (where applicable) will not be changed.'} /> 
                                
                                <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box" style={{ marginTop: "5px" }}>{comdetailsdata.label.PostalCode}</div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div style={{width:'90%', float:'left'}}>
                                            <Field className="k-textbox" name={'PostalCode'} id={'PostalCode'}
                                                placeholder={'Please Input'} 
                                                maxLength={6} 
                                                component={FormInput} 
                                                validator={postalCodeValidator} />
                                            </div>
                                            <div style={{width:'10%', float:'left', textAlign:'center',paddingTop:'5px'}}>
                                                <a className="k-icon k-i-zoom" style={{fontSize:'24px'}} onClick={(e)=>{
                                                    e.preventDefault();

                                                    let postCode = formRenderProps.valueGetter('PostalCode');
                                                    if(postCode === '' || postCode === undefined){
                                                       // showErrMsg('Postal Code is required');
                                                        return;
                                                    }
                                                    else if(postCode.length > 6 || !numericRegex.test(postCode) ) {
                                                       // showErrMsg('Input max 6 numeric characters');
                                                        return;
                                                    }

                                                    getAddressbyPostalCode(formRenderProps.valueGetter('PostalCode'));
                                                }}>
                                                </a>
                                            </div>
                                        </div>
                                </div>
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputBlock'} leftLabelName={comdetailsdata.label.BlkNo} 
                                    id={'BlkNo'} name={'BlkNo'} placeholder={'Please input'} maxLength={10} validator={blockValidator} /> 

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStreet'} leftLabelName={comdetailsdata.label.Street} 
                                    id={'Street'} name={'Street'} placeholder={'Please input'} 
                                    maxLength={66} validator={streetValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblInputFlrNum'} leftLabelName={comdetailsdata.label.FlrNum} 
                                    id={'FlrNum'} name={'FlrNum'} placeholder={'Please input'} maxLength={3}
                                    validator={levelValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblInputUno'} leftLabelName={comdetailsdata.label.UnitNo} 
                                    id={'UnitNo'} name={'UnitNo'}  placeholder={'Please input'} maxLength={6} 
                                    validator={unitNoValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblInputBld'} leftLabelName={comdetailsdata.label.BldName} 
                                    id={'BldName'} name={'BldName'}  placeholder={'Please input'} maxLength={66} 
                                    validator={buildingValidator} />
                      
                                <Field component={CusFormInput} 
                                    leftLabelId={'lblCountry'} leftLabelName={comdetailsdata.label.Country} 
                                    id={'Country'} name={'Country'} disabled={true} />

                                <FieldWrapper>
                                <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="text-right" style={{paddingBottom: "20px"}}>
                                        <div>
                                            <button type={'submit'} className="k-button btn btn-success" disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                        </div>
                                        </div>
                                    </div>
                                </div> 
                                </FieldWrapper>  
                            </fieldset>
                            </FormContainer>
                            : null }
                            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />   
                        </FormElement>
                    )}>
            </Form>
            {isSaving && <Loading />}                     
        </div>
    )
}

export default CompanyDetails;